import React, { useEffect, useState } from 'react'
import styles from "../../../../../assets/stylesheets/sass/Management/UserGroup.module.scss";
import { Tooltip } from '@qastanfit/qastan-ui';
import { handleGetAllGroups } from '../../../../../functions/fetch';
import { filterObjectsByValue } from '../../../../../functions/general/filter';
import { handleDeleteGroup } from '../../../../../functions/updates';
import AddGroup from './AddGroup';
import EditGroup from './EditGroup';
import { getTranslation } from '../../../../../functions/translation';

function UserGroups() {
  const [content_state, setcontent_state] = useState({});

  const [main_groups, setmain_groups] = useState([]);
  const [filtered_groups, setfiltered_groups] = useState([]);

  const [delete_group, setdelete_group] = useState(null);
  const [is_deleting, setis_deleting] = useState(false);

  const [add_group, setadd_group] = useState(false);

  const [edit_group, setedit_group] = useState(null);


  useEffect(()=>{
    fetch(process.env.REACT_APP_SERVER_LINK+"content").then(
      res => res.json()
    ).then(
        json => {
            setcontent_state(json)
        }
    )

    getGroups()

   
  }, [])

  const getGroups = async () => {
    const all_groups = await handleGetAllGroups(JSON.parse(window.sessionStorage.getItem("user_data")))
    if(all_groups.errorcode === 0){
      if(Array.isArray(all_groups.object)){
        setfiltered_groups(all_groups.object)
        setmain_groups(all_groups.object.reverse())
      }
      else {
        //No groups found
        console.log(all_groups)
      }
    }
    else {
      //Error while getting groups
      console.log(all_groups)
    }
  }

  const searchGroup = (value) => {
    let tmp_main = [...main_groups];
    let results = filterObjectsByValue(tmp_main, value);
    setfiltered_groups(results);
  }

  const deleteGroup = async (group_id) => {
    try {
      setis_deleting(true)
      let f = await handleDeleteGroup({token:JSON.parse(window.sessionStorage.getItem("user_data")).token, groupid:group_id})
      getGroups();
      setdelete_group(null)
      setis_deleting(false)
    } catch (error) {
      console.log(error)
      setis_deleting(false)
      setdelete_group(null)
    }
  }

  return (
    <>
    {add_group &&
    <AddGroup onCancel={()=>{setadd_group(false)}} onCreated={()=>{setadd_group(false); getGroups()}}/>
    }

    {edit_group &&
    <EditGroup group={edit_group} onCancel={()=>{setedit_group(null)}} onUpdated={()=>{setedit_group(null); getGroups()}}/>
    }

    {delete_group && 
    <div className={styles.popup}>
      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.title}>{getTranslation(content_state, "UserGroups", "delete_title", "Delete Group")}</p>
          <p className={styles.description}>{getTranslation(content_state, "UserGroups", "delete_description", "Are you sure to delete next group")}: <span className={styles.groupsname}>{delete_group.name}</span>?</p>
          <div className={styles.actions}>
            <button onClick={()=>{setdelete_group(null)}} className={`${styles.cancel} ${styles.action}`}>{getTranslation(content_state, "UserGroups", "delete_cancel", "Cancel")}</button>
            <button disabled={is_deleting} onClick={()=>{deleteGroup(delete_group.groupid)}} className={`${styles.delete} ${styles.action}`}>{is_deleting ? getTranslation(content_state, "UserGroups", "label_wait", "Please wait...") : getTranslation(content_state, "UserGroups", "delete_confirm", "Delete")}</button>
          </div>
        </div>
      </div>
    </div>
    }

    <div className={styles.main}>
      <div className={styles.header}>
        <h2 className={styles.title}>{getTranslation(content_state, "UserGroups", "main_title", "User Groups")}</h2>
        <button onClick={()=>{setadd_group(true)}} className={styles.button}>{getTranslation(content_state, "UserGroups", "button_newgroup", "New group")}</button>
      </div>

      <div className={styles.search}>
        <svg className={styles.icon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M17.4583 17.5L13.8333 13.875" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
        <input onChange={(e)=>{searchGroup(e.currentTarget.value)}} className={styles.input} type="text" placeholder={getTranslation(content_state, "UserGroups", "main_search_placeholder", "Find a group (name/relationship)")}/>
      </div>

      <div className={styles.table_wrapper}>
        <div className={styles.table_inner_wrapper}>
          <table className={styles.table}>
            <tbody>
              <tr className={styles.th}>
                <th className={styles.th_item}>{getTranslation(content_state, "UserGroups", "main_table_groupsname", "Groupsname")}</th>
                <th className={styles.th_item}>{getTranslation(content_state, "UserGroups", "main_table_amountmembers", "Amount members")}</th>
                <th className={styles.th_item} style={{width:"6rem"}}></th>
              </tr>

              {Array.isArray(filtered_groups) && filtered_groups.reverse().map((group, index)=>{
                return (
                  <tr className={styles.tr} key={index}>
                    <td className={styles.td_item}>{group.name || ""}</td>
                    <td className={styles.td_item}>{Array.isArray(group.members) ? group.members.length : "0"}</td>
                    <td className={`${styles.td_item} ${styles.td_actions}`}>
                      <Tooltip text={getTranslation(content_state, "UserGroups", "main_table_editgroup", "Edit group")} position="left"><button onClick={()=>{setedit_group(group)}} className={styles.action}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_201_247)"><path d="M9.16675 3.33333H3.33341C2.89139 3.33333 2.46746 3.50893 2.1549 3.82149C1.84234 4.13405 1.66675 4.55797 1.66675 5V16.6667C1.66675 17.1087 1.84234 17.5326 2.1549 17.8452C2.46746 18.1577 2.89139 18.3333 3.33341 18.3333H15.0001C15.4421 18.3333 15.866 18.1577 16.1786 17.8452C16.4912 17.5326 16.6667 17.1087 16.6667 16.6667V10.8333" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M15.4167 2.08333C15.7483 1.75181 16.1979 1.56557 16.6667 1.56557C17.1356 1.56557 17.5852 1.75181 17.9167 2.08333C18.2483 2.41485 18.4345 2.86449 18.4345 3.33333C18.4345 3.80217 18.2483 4.25181 17.9167 4.58333L10.0001 12.5L6.66675 13.3333L7.50008 10L15.4167 2.08333Z" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_201_247"><rect width="20" height="20" fill="white"/></clipPath></defs></svg></button></Tooltip>
                      <Tooltip text={getTranslation(content_state, "UserGroups", "main_table_deletegroup", "Delete group")} position="left"><button onClick={()=>{setdelete_group(group)}} className={styles.action}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 5H17.5" stroke="#808080" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M15.8334 5V16.6667C15.8334 17.5 15.0001 18.3333 14.1667 18.3333H5.83341C5.00008 18.3333 4.16675 17.5 4.16675 16.6667V5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M6.66675 5V3.33333C6.66675 2.5 7.50008 1.66666 8.33341 1.66666H11.6667C12.5001 1.66666 13.3334 2.5 13.3334 3.33333V5" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M8.33325 9.16666V14.1667" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M11.6667 9.16666V14.1667" stroke="#808080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></button></Tooltip>
                    </td>
                  </tr>
                )
              })}

              
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </>
  )
}

export default UserGroups